/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector } from '@reduxjs/toolkit';
import _ from 'lodash';
import { selectUserData } from '../user/userAccounts/userAccounts.slice';
import { SubmissionStatus } from '../../../models/SubmissionStatus';

export const submissionSliceName = 'submission';

/* Selectors */
const selectSubmission = state => state[submissionSliceName];
export const selectSubmissionStatus = createSelector(selectSubmission, ({ status }) => status);
export const selectSubmissionData = createSelector(selectSubmission, selectUserData, ({ data }, userData) => {
  const submission = { ...data };
  if (submission?.status === SubmissionStatus.READY_TO_SIGN.id) {
    _.set(submission, 'signer.currentSigner.[0]', { state: 'CONFIRMED', ...userData });
  }
  return submission;
});
export const selectSubmissionUiSchema = createSelector(selectSubmission, ({ uiSchema }) => uiSchema);
export const selectAttachmentsAreLoading = createSelector(
  selectSubmission,
  ({ loadingAttachmentsCount }) => loadingAttachmentsCount > 0,
);
export const selectSubmissionWorkflowValidations = createSelector(
  selectSubmission,
  ({ workflowValidations }) => workflowValidations,
);
export const selectSubmissionValidationErrors = createSelector(
  selectSubmission,
  ({ validationErrors }) => validationErrors,
);
export const selectSubmissionIsRightMenuOpen = createSelector(
  selectSubmission,
  ({ isRightMenuOpen }) => isRightMenuOpen,
);

export const selectSubmissionLockedSubmissionId = createSelector(
  selectSubmission,
  ({ lockedSubmissionId }) => lockedSubmissionId,
);
